<div class="container nesting">
  @for (topLevel of metadata$ | async | keyvalue; track topLevel) {
    <div class="row">
      @if (topLevel.key == 'dataFeedElement') {
        <div class="col-12">
          <h2>datafeeds</h2>
          @for (dataFeedElement of topLevel.value; track dataFeedElement; let i = $index) {
            <div class="container nesting"
              >
              <div class="row">
                <div class="col-12">
                  <h3>datafeed[{{ i }}]</h3>
                  @for (dataFeed of dataFeedElement | keyvalue; track dataFeed) {
                    <div class="container nesting">
                      <div class="row">
                        <div class="col-12">
                          <div class="cl-spacing-box">
                            @switch (dataFeed.key) {
                              @case ('potentialAction') {
                                <div class="col-12">
                                  <h4>Potential Action</h4>
                                  <pre> {{ dataFeed.value | json }} </pre>
                                </div>
                              }
                              @case ('releasedEvent') {
                                <div class="col-12">
                                  <h4>Released Event</h4>
                                  <pre> {{ dataFeed.value | json }} </pre>
                                </div>
                              }
                              @case ('trailer') {
                                <div class="col-12">
                                  <h4>Trailer</h4>
                                  <pre> {{ dataFeed.value | json }} </pre>
                                </div>
                              }
                              @case ('actor') {
                                <div class="col-12">
                                  <h4>Actors</h4>
                                  <table class="cl-table-data">
                                    <thead>
                                      <tr>
                                        <th class="cl-table-head">Type</th>
                                        <th class="cl-table-head">Name</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (actor of dataFeed.value; track actor) {
                                        <tr>
                                          <td>{{ actor['@type'] }}</td>
                                          <td>{{ actor['name'] }}</td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              }
                              @case ('description') {
                                <div class="col-12">
                                  <h4>Description</h4>
                                  <table class="cl-table-data">
                                    <thead>
                                      <tr>
                                        <th class="cl-table-head">Language</th>
                                        <th class="cl-table-head">Description</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (localizedText of dataFeed.value; track localizedText) {
                                        <tr>
                                          <td>{{ localizedText['@language'] }}</td>
                                          <td><p>{{ localizedText['@value'] }}</p></td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              }
                              @case ('name') {
                                <div class="col-12">
                                  <h4>Name</h4>
                                  <table class="cl-table-data">
                                    <thead>
                                      <tr>
                                        <th class="cl-table-head">Language</th>
                                        <th class="cl-table-head">Name</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (localizedText of dataFeed.value; track localizedText) {
                                        <tr>
                                          <td>{{ localizedText['@language'] }}</td>
                                          <td><p>{{ localizedText['@value'] }}</p></td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              }
                              @case ('director') {
                                <div class="col-12">
                                  <h4>Director</h4>
                                  <table class="cl-table-data">
                                    <thead>
                                      <tr>
                                        <th class="cl-table-head">Type</th>
                                        <th class="cl-table-head">Name</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (actor of dataFeed.value; track actor) {
                                        <tr>
                                          <td>{{ actor['@type'] }}</td>
                                          <td>{{ actor['name'] }}</td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              }
                              @case ('identifier') {
                                <div class="col-12">
                                  <h4>Identifiers</h4>
                                  <table class="cl-table-data">
                                    <thead>
                                      <tr>
                                        <th class="cl-table-head">Property ID</th>
                                        <th class="cl-table-head">Value</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (identifier of dataFeed.value; track identifier) {
                                        <tr>
                                          <td>{{ identifier['propertyID'] }}</td>
                                          <td>{{ identifier['value'] }}</td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              }
                              @case ('genre') {
                                <div class="col-12">
                                  <h4>Genres</h4>
                                  <div class="cl-spacing-box-tiny">
                                    @for (genre of dataFeed.value; track genre) {
                                      <span class="badge cl-badge-text"
                                      >{{ genre }}</span>
                                    }
                                  </div>
                                </div>
                              }
                              @case ('contentRating') {
                                <div class="col-12">
                                  <h4>Content Rating</h4>
                                  <p class="cl-p-large">{{ dataFeed.value }}</p>
                                </div>
                              }
                              @case ('duration') {
                                <div class="col-12">
                                  <h4>Duration</h4>
                                  <p class="cl-p-large">{{ dataFeed.value }}</p>
                                </div>
                              }
                              @case ('image') {
                                @for (image of dataFeed.value; track image; let i = $index) {
                                  <div class="col-12">
                                    <h4>Image[{{ i }}]</h4>
                                    @for (pro of image | keyvalue; track pro) {
                                      <div class="container nesting">
                                        <div class="col-12">
                                          <dl class="cl-dl cl-dl-tight">
                                            <dt>{{ pro.key }}</dt>
                                            @switch (pro.key) {
                                              @case ('additionalProperty') {
                                                <dd>
                                                  <table class="cl-table-data">
                                                    <thead>
                                                      <tr>
                                                        <th class="cl-table-head">additionalProperty</th>
                                                        <th class="cl-table-head">Values</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      @for (additionalProperty of image.additionalProperty; track additionalProperty) {
                                                        <tr>
                                                          <td>{{ additionalProperty['name'] }}</td>
                                                          <td>
                                                            <div class="cl-spacing-box-tiny">
                                                              @for (value of additionalProperty['value'] ; track value) {
                                                                <span class="badge cl-badge-text"
                                                                >{{ value }}</span>
                                                              }
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      }
                                                    </tbody>
                                                  </table>
                                                </dd>
                                              }
                                              @case ('contentUrl') {
                                                <dd>
                                                  <img [src]="getImgUrl(pro.value)">
                                                </dd>
                                              }
                                              @default {
                                                <dd>
                                                  <p class="cl-p">{{ pro.value }}</p>
                                                </dd>
                                              }
                                            }
                                          </dl>
                                        </div>
                                      </div>
                                    }
                                  </div>
                                }
                              }
                              @default {
                                <div class="col-12">
                                  <h4>{{ dataFeed.key }}</h4>
                                  <div class="col-12">
                                    <pre> {{ dataFeed.value }}</pre>
                                  </div>
                                </div>
                              }
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          <div class="col-12"></div>
        </div>
      } @else {
        <div class="col-2">
          <pre>{{ topLevel.key }}</pre>
        </div>
        <div class="col-10">
          <pre> {{ topLevel.value }}</pre>
        </div>
      }
    </div>
  }
</div>
